import { FormControlLabel, Radio, Stack } from '@mui/material'
import { com } from '@eidu/web'
import EntitySelectorInput from './EntitySelectorInput'
import { useSortedEntityTypes } from '../../io/useEntityTypes'
import { withKey } from '../../util/withKey'
import FormKeyField from './FormKeyField'
import TrimmedTextField from './TrimmedTextField'
import EntityChoice = com.eidu.sharedlib.form.definition.EntityChoice
import SingleChoiceStyle = com.eidu.sharedlib.form.definition.SingleChoiceStyle

type EntityChoiceItemProps = {
  item: EntityChoice
  onChange?: (item: EntityChoice) => void
}

const EntityChoiceItem: React.FC<EntityChoiceItemProps> = ({ item, onChange }) => {
  const entityTypes = useSortedEntityTypes()

  return (
    <Stack spacing={2} sx={{ p: 2, backgroundColor: 'background.paper', borderRadius: 1 }}>
      <Stack direction="row" spacing={2} alignItems="flex-start">
        <Stack spacing={2} sx={{ flex: 1 }}>
          <TrimmedTextField
            label="Prompt"
            value={item.prompt}
            onChange={(e) =>
              onChange?.(withKey(item.copy(e.target.value, item.key, item.entities, item.style, item.required), item))
            }
            fullWidth
            disabled={!onChange}
          />
          <FormKeyField
            value={item.key}
            onChange={(e) =>
              onChange?.(
                withKey(item.copy(item.prompt, e.target.value, item.entities, item.style, item.required), item)
              )
            }
            fullWidth
            disabled={!onChange}
          />
          <Stack direction="row" spacing={2}>
            <FormControlLabel
              control={
                <Radio
                  checked={item.style.name === SingleChoiceStyle.DropDown.name}
                  onChange={() =>
                    onChange?.(
                      withKey(
                        item.copy(item.prompt, item.key, item.entities, SingleChoiceStyle.DropDown, item.required),
                        item
                      )
                    )
                  }
                  disabled={!onChange}
                />
              }
              label="Dropdown"
            />
            <FormControlLabel
              control={
                <Radio
                  checked={item.style.name === SingleChoiceStyle.Radio.name}
                  onChange={() =>
                    onChange?.(
                      withKey(
                        item.copy(item.prompt, item.key, item.entities, SingleChoiceStyle.Radio, item.required),
                        item
                      )
                    )
                  }
                  disabled={!onChange}
                />
              }
              label="Radio"
            />
          </Stack>
          <EntitySelectorInput
            entityTypes={entityTypes ?? []}
            entitySelector={item.entities}
            setEntitySelector={(entities) =>
              onChange?.(withKey(item.copy(item.prompt, item.key, entities, item.style, item.required), item))
            }
            disabled={!onChange}
            complexSelectors={false}
          />
        </Stack>
      </Stack>
    </Stack>
  )
}

export default EntityChoiceItem
